/* import { AuthenticatedTemplate } from '@azure/msal-react'; */
import { NavigationBar } from './NavigationBar';

export const PageLayout = (props) => {
    
    return (
        <>
            <NavigationBar />
            {/* <div style={{ width:'100%', textAlign:'center', backgroundColor : 'red', border: '5px solid black', color : 'white' }} >
                Due to planned database maintenance, map functionality in this tool will be impacted from 11/24-11/26. You can log in to view your existing data, but you will not be able to upload, edit or certify any boundaries or certify WWTP locations until the maintenance ends.
            </div> */}
            {props.children}
            <br />
              {/* <AuthenticatedTemplate> */}
                <footer>
                    <center>
                        <span style={{ fontSize: '8px' }}></span>
                    </center>
                </footer>
              {/* </AuthenticatedTemplate> */}
        </>
    );
};